import {defineMessages} from 'react-intl';

const messages = defineMessages({
    NEW: {
        id: 'export.new',
        defaultMessage: 'New'
    },
    PROCESSING: {
        id: 'export.processing',
        defaultMessage: 'Processing'
    },
    ERROR: {
        id: 'export.error',
        defaultMessage: 'Error'
    },
    TO_MANY: {
        id: 'export.toMany',
        defaultMessage: 'Error - To many records'
    },
    FINISH: {
        id: 'export.finish',
        defaultMessage: 'Finish'
    },
    MISSING_WORKING_HOURS: {
        id: 'export.missingWorkingHours',
        defaultMessage: 'Error - Missing working hours'
    },
});

export default messages;
